var FailureCodes;
(function(FailureCodes) {
    FailureCodes['CartNotFoundFailure'] = 'cartNotFound';
    FailureCodes['InvalidCartFailure'] = 'cartNotInActiveState';
    FailureCodes[// eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    'ProductNoLongerExistsFailure'] = 'cartNotInActiveState';
})(FailureCodes || (FailureCodes = {}));
const getFailureCodes = (failures)=>{
    return failures.map((failure)=>{
        if (failure.__typename && FailureCodes[failure.__typename]) {
            return `cart.errors.${FailureCodes[failure.__typename]}`;
        } else {
            return `cart.errors.somethingWentWrong`;
        }
    });
};
const mapCartError = (failures)=>{
    return failures.map((error)=>{
        return {
            type: 'FAILED',
            error: FailureCodes[error.__typename]
        };
    });
};

export { FailureCodes, getFailureCodes, mapCartError };
//# sourceMappingURL=get-failure-error-codes.js.map
